import { CommentType } from '@models/comment/CommentType'
import { Expose } from 'class-transformer'

class PenNameType {
  user: {
    id: number
  }
}
class BookType {
  id: number

  title: string

  penName: PenNameType

  guestCommentable: boolean

  commentable: boolean

  isUserHasBlockedComment: boolean
}

export class CommentNotificationType extends CommentType {
  @Expose()
  book: BookType
}
